// Podrazumevani tekst za "Individualne preporuke" - popunjava se kod novog plana,
// a nutricionista ga po potrebi doteruje za svakog klijenta.
export const DEFAULT_INDIVIDUAL_RECOMMENDATIONS =
`Tečnost: Potrebno je uneti 2l tečnosti dnevno. Tečnost je voda, voda sa limunom, čaj bez šećera I mineralna voda (najviše dve čaše dnevno).

*Trikovi za unošenje više tečnosti:
- Držite vodu u blizini, da je uvek vidite – na taj način je veća verovatnoća da ćete popiti više tečnosti.
- Ako niste preterani ljubitelj ukusa obične vode, možete da napravite 1l blage limunade. U limunadu dodajte steviju i malo cimeta. Ova kombinacija ublažava potrebu za slatkim, a možete je piti u toku dana.
- Skuvajte 0,5l čaja dnevno, pa u malim gutljajima pijte u toku dana. Čaj možete zasladiti stevijom i dodati limun, ukoliko volite.
- Ako ni ovo ne bude uspelo, možete da probate sa Waterdrop tableticama koje su zaslađene stevijom.

Kafa: Do dve domaće ili nes ili espreso kafe, bez mleka i bez šećera. Poželjno je da se kafa pije posle obroka.

Fizička aktivnost: Poželjna je svakodnevna fizička aktivnost! Šetnja, brzi hod, minimum 40 minuta dnevno. Najbolje je kad bi mogli da pređete 6000-10000 koraka dnevno.`;
